module.exports = {
  baseURL: process.env.NODE_ENV === 'development'
    ? 'http://192.168.3.49:9019'//
    : 'http://ehall.wtbu.edu.cn:9002',
  userInfoBaseURL: 'http://ehall.wtbu.edu.cn:9004',
  // userInfoBaseURL:'http://192.168.3.96:9020',
  contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
  requestTimeout: 10000,
  successCode: [200, 0, '200', '0'],
  statusName: 'code',
  messageName: 'msg',
  ipURL: 'https://auth.wtbu.edu.cn',//登录和退出用的ip地址http://192.168.3.6:8199
  serviceUrl: 'http://ehall.wtbu.edu.cn:9003',//'http://192.168.3.96:9190',//service的IP地址
  //文件上传路径
  uploadPath: 'http://ztc.wtbu.edu.cn:9003/api/base/files/upload/', // '' 'http://192.168.3.96:9087/api/base/files/upload/'
  //文件获取路径
  fileAcquisition: 'http://ztc.wtbu.edu.cn/upload', //'' 'http://192.168.3.96:8091/upload'
  //校长直通车地址
  xzztcUrl: "http://ztc.wtbu.edu.cn:9001",
  //通知公告查询地址
  noticessoUrl: "http://sso.wtbu.cn:8008",
  //学校日历,课表查询地址
  calendarSsoUrl: "http://sso.wtbu.cn:8010",
  OAUrl: 'https://oa.wtbu.edu.cn/seeyon/cas/sso.do',//OA系统的地址   
  jwUrl: 'https://jxgl.wtbu.edu.cn/eams/localLogin.action',//教务系统地址
  jsdtxgg: 'https://oa.wtbu.edu.cn/seeyon/bulData.do?method=bulIndex',
  devServer: {
    port: 8081,//端口号 
    open: true,
  }
}